import { createSelector } from "reselect"
import { filter, get, toLower } from "lodash"
import { ALL_DATASET_ACCESS_TEAM } from "helpers/datasets"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeResourcePermissionsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"
import { getFullResourceType } from "modules/resources/helpers"

const EMPTY_ARRAY = []

export const getResourceType = (_, props) => getFullResourceType(props.params.resourceType)
export const getResourceId = (_, props) => get(props, "resourceTeams.resource.id")
export const getResourceTeams = (_, props) => get(props, "resourceTeams.resource.teams", EMPTY_ARRAY)
const getAccountTeamsRaw = (_, props) => get(props, "accountTeams.teams", EMPTY_ARRAY)
export const getPermissionLevel = (_, props) => get(props, "resourceTeams.resource.permissionLevel")

export const getAccountTeams = createSelector(
  [getAccountTeamsRaw],
  (accountTeams) => filter(accountTeams, team => toLower(team.name) !== toLower(ALL_DATASET_ACCESS_TEAM.NAME)),
)

export const getTabs = createSelector(
  [getRoute, getPath, getResourceType, getIsOpPro],
  computeResourcePermissionsTabs,
)
